module.exports = __webpack_public_path__ + "img/cate-arrow.9fc6fb37.png";